import React from 'react';
import { useSelector } from 'react-redux';
import { Form, RadioGroup, Radio } from 'react-form';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { Select } from '../../../components/Form';
import { createReactFormValidator } from '../../../utils/validation';

import styles from '../nuoV2.scss';
import { NewUserOnboardingIDs } from '../../../components/Analytics/testIDConfig';
import { required, formHasErrors } from '../../../utils/form-validation';

const PickleballSelfRatingForm = props => {
    const { handleSubmit } = props;

    const auth = useSelector(({ auth }) => {
        const { user: { utrRange, utrRangeRequired, birthdate } } = auth;
        return {
            auth: {
                user: {
                    utrRange,
                    utrRangeRequired,
                    birthdate,
                },
            },
        };
    });
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const onboarding = useSelector(({ onboarding }) => onboarding);

    const { types = {} } = coreUI;
    const { pickleballRating = {} } = types;
    const { levelTypes = [], ratingTypes = [] } = pickleballRating;

    const { utrRangeSurvey: { saving, error } } = onboarding;
    const ageRestriction = {
        min: 3,
    };
    if (auth.user?.birthdate) {
        const currentAge = moment().diff(auth.user.birthdate, 'years');
        ageRestriction.max = currentAge;
    }

    return (
        <div className={styles.page}>
            <Form onSubmit={values => handleSubmit(values)}>
                {({ submitForm, errors, getError, values }) => {
                    const levelError = getError('level');
                    const levelValue = values.level;
                    return (
                        <form onSubmit={submitForm} id="OnboardingSurveyForm" data-testid="nuo-v2.pickleball-self-rating.form">
                            <div className={`form-group ${styles.radioGroup} row mb24 ${levelError && 'is-invalid'}`}>
                                <div className="col-12">
                                    <RadioGroup
                                        field="level"
                                        validate={createReactFormValidator(required)}
                                        data-testid={`${NewUserOnboardingIDs.PickleballLevelTypes.component}-${NewUserOnboardingIDs.PickleballLevelTypes.location}-${NewUserOnboardingIDs.PickleballLevelTypes.id}`}
                                    >
                                        <label className={'mb8 fw500'} data-testid="nuo-v2.pickleball-self-rating.level-label">
                                            How would you describe your level of pickleball play?
                                        </label>
                                        {levelTypes.map(({ id, label }) => (
                                            <div className="d-flex aic mb8" key={`level-${id}`} data-testid={`nuo-v2.pickleball-self-rating.level-option-${id}`}>
                                                <Radio
                                                    id={`level-${id}`}
                                                    value={id}
                                                    checked={levelValue === id}
                                                    data-testid={`nuo-v2.pickleball-self-rating.level-option-${id}.input`}
                                                />
                                                <label htmlFor={`level-${id}`} className="mb0" data-testid={`nuo-v2.pickleball-self-rating.level-option-${id}.label`}>&nbsp;{label}</label>
                                            </div>
                                        ))}
                                    </RadioGroup>
                                    {levelError && (
                                        <div className="text-error fs13" data-testid="nuo-v2.pickleball-self-rating.level-error">
                                            This field is required.
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb16">
                                    <label className={'fw500 mb0'} data-testid="nuo-v2.pickleball-self-rating.rating-label">
                                        Do you have an official USA Pickleball rating?
                                    </label>
                                    <div className="fs14 fw300" data-testid="nuo-v2.pickleball-self-rating.rating-hint">
                                        If yes, select your rating. If no, select not applicable.
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className={styles.input}>
                                        <Select
                                            id="rating"
                                            field="rating"
                                            options={ratingTypes}
                                            validate={required}
                                            themeV3
                                            data-testid={`${NewUserOnboardingIDs.PickleballRating.component}-${NewUserOnboardingIDs.PickleballRating.location}-${NewUserOnboardingIDs.PickleballRating.id}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            {formHasErrors(errors) && (
                                <div className="row mb16">
                                    <div className="col-12">
                                        <div className="pt24 text-center text-error text-small" data-testid="nuo-v2.pickleball-self-rating.form-error">
                                            You must complete the survey to get a rating.
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!!error && (
                                <div className="row mb16">
                                    <div className="col-12">
                                        <div className="pt24 text-center text-error text-small" data-testid="nuo-v2.pickleball-self-rating.api-error">
                                            Error submitting form. {error}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className={`col-12 text-center`}>
                                    <div className={styles.submit}>
                                        <button
                                            data-testid={`${NewUserOnboardingIDs.PickleballSubmitButton.component}-${NewUserOnboardingIDs.PickleballSubmitButton.location}-${NewUserOnboardingIDs.PickleballSubmitButton.id}`}
                                            type="submit"
                                            className={`btn btn-primary text-uppercase`}
                                            disabled={saving}
                                        >
                                            {saving ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

export default withRouter(PickleballSelfRatingForm);
